import React from 'react';
import { array, string } from 'prop-types';
import { Tile } from 'components/Widgets/';
import {
  StyledLabel,
  StyledStatus,
  StyledAvatar,
  StyledTileBody,
  StyledTileItem,
  StyledBoldFont,
  StyledLogoWrapper,
  StyledLeftSection,
  StyledRightSection,
  StyledAvatarSection,
  StyledCustomerNameLabel,
} from 'components/Order/Current/Current.styled';
import { getImageUrl, getOrderNumber } from 'utils/';
import { ReactComponent as ArrowIcon } from 'icons/order.svg';

/**
 * @param {{
 * data : []
 * priceUnit: string
 * companyName: string
 * }} param
 */
function Current({ data, priceUnit, companyName }) {
  return (
    <Tile caption="Active Orders">
      <StyledTileBody>
        {data.map(function (item) {
          const { id, tag, customer, total_cost: totalCost } = item;
          const { name = '', photo } = customer || {};
          const url = getImageUrl(photo);
          const orderNumber = getOrderNumber({
            id,
            companyName,
            prefix: '#',
          });
          const orderTotal = parseFloat(totalCost).toLocaleString();
          return (
            <StyledTileItem key={id}>
              <StyledLogoWrapper>
                <ArrowIcon />
              </StyledLogoWrapper>
              <StyledLeftSection>
                <StyledLabel>
                  <StyledBoldFont>Order # </StyledBoldFont>
                  {orderNumber}
                </StyledLabel>
                <StyledCustomerNameLabel>{name}</StyledCustomerNameLabel>
              </StyledLeftSection>
              <StyledAvatarSection>
                <StyledAvatar src={url} alt="customer" />
              </StyledAvatarSection>
              <StyledRightSection>
                <StyledLabel>
                  {priceUnit}.<StyledBoldFont> {orderTotal}</StyledBoldFont>
                </StyledLabel>
                <StyledStatus>{tag}</StyledStatus>
              </StyledRightSection>
            </StyledTileItem>
          );
        })}
      </StyledTileBody>
    </Tile>
  );
}

Current.propTypes = {
  data: array,
  priceUnit: string,
  companyName: string,
};

export default Current;
